import { render, staticRenderFns } from "./swiperBgSetting.vue?vue&type=template&id=4f1993f8&scoped=true&"
import script from "./swiperBgSetting.vue?vue&type=script&lang=js&"
export * from "./swiperBgSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1993f8",
  null
  
)

export default component.exports